<div class="flex items-center justify-center p-7">
	<div class="w-full lg:w-3/5 bg-white rounded overflow-hidden shadow-sm">
		<form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="space-y-2">
			<div class="p-7 space-y-7">
				<div class="grid grid-cols-1 gap-4">
					<div class="">
						<label class="text-sm required" for="currentPassword">Ancien mot de passe</label>
						<div class="relative">
							<input [type]="showCurrentPassword ? 'text' : 'password'" id="currentPassword"
								formControlName="currentPassword"
								class="input placeholder:text-[12px] placeholder:text-slate-400 w-full pr-10"
								placeholder="Ancien mot de passe">
							<button type="button" (click)="toggleCurrentPasswordVisibility()"
								class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 z-10 bg-white">
								<lucide-icon [img]="showCurrentPassword ? EyeOff : Eye" [size]="20"></lucide-icon>
							</button>
						</div>
					</div>
					<div class="">
						<label class="text-sm required" for="newPassword">Nouveau mot de passe</label>
						<div class="relative">
							<input [type]="showNewPassword ? 'text' : 'password'" id="newPassword" formControlName="newPassword"
								class="input placeholder:text-[12px] placeholder:text-slate-400 w-full pr-10"
								placeholder="Nouveau mot de passe">
							<button type="button" (click)="toggleNewPasswordVisibility()"
								class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 z-10 bg-white">
								<lucide-icon [img]="showNewPassword ? EyeOff : Eye" [size]="20"></lucide-icon>
							</button>
						</div>
					</div>
					<div class="">
						<label class="text-sm required" for="confirmPassword">Confirmer le nouveau mot de passe</label>
						<div class="relative">
							<input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
								formControlName="confirmPassword"
								class="input placeholder:text-[12px] placeholder:text-slate-400 w-full pr-10"
								placeholder="Confirmer le nouveau mot de passe">
							<button type="button" (click)="toggleConfirmPasswordVisibility()"
								class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 z-10 bg-white">
								<lucide-icon [img]="showConfirmPassword ? EyeOff : Eye" [size]="20"></lucide-icon>
							</button>
						</div>
						<div *ngIf="passwordMismatchError" class="text-red-500 text-sm mt-1">
							Les mots de passe ne correspondent pas
						</div>
					</div>
				</div>
			</div>
			<div class="bg-slate-50 p-5 flex items-center justify-center gap-4">
				<button type="submit" [disabled]="!passwordForm.valid || loading"
					class="text-white bg-primary px-4 py-2 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
					<div *ngIf="loading" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin">
					</div>
					<span>{{ loading ? 'Modification en cours...' : 'Enregistrer les changements' }}</span>
				</button>
			</div>
		</form>
	</div>
</div>